import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const TobaccoIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M7.3 11.4c-2.9 0-5.2 2.4-5.2 5.2s2.4 5.2 5.2 5.2 5.2-2.4 5.2-5.2-2.3-5.2-5.2-5.2zm0 7.5c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2-.9 2.2-2.2 2.2z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M21.9 19.8V9.6H9.3v.3c3.1.6 5.3 3.4 5.4 6.5 0 1.7-.7 3.3-1.8 4.5h8c.5 0 1-.5 1-1.1z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M13.7 5.3h3.8c.2 0 .6 0 .6-.4V2.4c-.2-.2-.5-.3-.9-.3H14c-.3 0-.6.1-.9.3L13 4.9c.1.4.7.4.7.4z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M21.9 3.6c0-.6-.5-1.2-1.1-1.2h-1.2v2.5c0 1.1-.9 2-2 2h-3.9c-1.1.1-2-.8-2.1-1.9V2.4h-1.3c-.6 0-1.1.5-1.1 1.2v4.5h12.6V3.6h.1z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default TobaccoIcon;
